import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/room/types'
import RoomEntity, { IRoomProps } from '@/entities/Room'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export default class RoomRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<IRoomProps>) {
    this.store.commit(new types.Store({ ...value }))
  }

  get data(): IResponseProps<IRoomProps> {
    return { ...this.store.state.room.response }
  }

  set talk(value: IResponseProps<IRoomProps>) {
    this.store.commit(new types.Talk({ ...value }))
  }

  get talk(): IResponseProps<IRoomProps> {
    return { ...this.store.state.room.talk }
  }

  get individual(): IResponseProps<IRoomProps> {
    return EmptyResponsePropsFactory({
      ...this.store.state.room.response,
      items: this.store.state.room.response.items.filter((prop: IRoomProps) => {
        return (prop.properties?.group || false) === false
      })
    })
  }

  get group(): IResponseProps<IRoomProps> {
    return EmptyResponsePropsFactory({
      ...this.store.state.room.response,
      items: this.store.state.room.response.items.filter((prop: IRoomProps) => {
        return prop.properties?.group || false
      })
    })
  }

  set current(value: IRoomProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): IRoomProps | null {
    return this.store.state.room.current
  }

  set top(value: IRoomProps | null) {
    this.store.commit(new types.Top(value))
  }

  get top(): IRoomProps | null {
    return this.store.state.room.top
  }

  get entity(): RoomEntity {
    return new RoomEntity(this.store.state.room.current)
  }

  set scrollTop(value: number) {
    this.store.commit(new types.ScrollTop(value))
  }

  get scrollTop(): number {
    return this.store.state.room.scrollTop
  }

  set filter(value: string) {
    this.store.commit(new types.Filter(value))
  }

  get filter(): string {
    return this.store.state.room.filter
  }

  set priority(value: string | null) {
    this.store.commit(new types.Priority(value))
  }

  get priority(): string | null {
    return this.store.state.room.priority
  }

  refresh() {
    this.store.commit(new types.Refresh())
  }

  read(id: string) {
    const items = this.store.state.room.response.items.map((item) => {
      if (item.id === id) {
        return { ...item, unreadCount: 0 }
      }
      return item
    })
    this.store.commit(new types.Store({ ...this.store.state.room.response, items }))
  }

  unread(id: string) {
    const items = this.store.state.room.response.items.map((item) => {
      if (item.id === id) {
        return { ...item, unreadCount: item.unreadCount + 1 }
      }
      return item
    })
    this.store.commit(new types.Store({ ...this.store.state.room.response, items }))
  }
}
